import { useEffect, useRef, useState } from "react";

import { Input } from "@/shared/ui/input";
import { useDebounce } from "@/shared/hooks/useDebounce";
import { useURLParamsData } from "@/shared/hooks/useURLParamsData";
import { cn } from "@/shared/lib/utils";

interface TableSearchInputProps {
  search?: string;
  setSearch?: (value: string) => void;
  setPage?: (value: number) => void;
  className?: string;
}

export const TableSearchInput = ({
  search: propSearch,
  setSearch: propSetSearch,
  setPage: propSetPage,
  className,
}: TableSearchInputProps) => {
  const {
    setSearch: urlSetSearch,
    setPage: urlSetPage,
    search: urlSearch,
  } = useURLParamsData();

  // REFACTOR
  const urlSetSearchRef = useRef(urlSetSearch);
  const urlSetPageRef = useRef(urlSetPage);

  const activeSearch = propSearch ?? urlSearch;
  const setActiveSearch = propSetSearch ?? urlSetSearchRef.current;
  const setActivePage = propSetPage ?? urlSetPageRef.current;

  const [searchTerm, setSearchTerm] = useState(activeSearch);
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const searchRef = useRef(activeSearch);

  useEffect(() => {
    setSearchTerm(activeSearch);
  }, [activeSearch]);

  useEffect(() => {
    setActiveSearch(debouncedSearchTerm);

    if (searchRef.current !== debouncedSearchTerm) {
      setActivePage(1);
    }

    searchRef.current = debouncedSearchTerm;
  }, [debouncedSearchTerm, setActivePage, setActiveSearch]);

  return (
    <Input
      type="search"
      placeholder="Поиск..."
      className={cn("max-w-sm text-textColor", className)}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
  );
};
